import { CitationNode, ModelType } from '@livv/models';
import { SxProps, Typography } from '@mui/material';
import { FC } from 'react';
import ExternalPreview from './ExternalPreview';
import InternalPreview from './InternalPreview';
import { ModelTypeLogo } from '@components/search';

const contentSx: SxProps = {
    ':hover, :focus': {
        bgcolor: 'grey.700',
    },
    alignItems: 'center',
    border: 2,
    borderColor: 'grey.600',
    borderRadius: 1,
    display: 'grid',
    gap: 3,
    gridTemplateColumns: '120px 1fr',
    p: 2,
};

interface PreviewCardProps {
    articleData?: [string, string, boolean];
    citationData?: CitationNode;
    isExternal?: boolean;
    modelType?: ModelType;
    title: string;
}

const PreviewCard: FC<PreviewCardProps> = ({
    articleData,
    citationData,
    isExternal = false,
    modelType = ModelType.LAW_TEXT,
    title,
}) => {
    // this content is basic, complete as needed
    const mainContent = (
        <>
            <ModelTypeLogo modelType={modelType} displayVertically />
            <Typography variant="h4">{title}</Typography>
        </>
    );

    if (isExternal && articleData) {
        return (
            <ExternalPreview articleData={articleData} sx={contentSx}>
                {mainContent}
            </ExternalPreview>
        );
    }
    if (citationData) {
        return (
            <InternalPreview citation={citationData} sx={contentSx}>
                {mainContent}
            </InternalPreview>
        );
    }

    return null;
};

export default PreviewCard;
